import { IAuthRoleModel } from '@common/models/Security/AuthRoleModel';
import { isEmpty } from 'lodash';
import React from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
export interface UserProfileRolesModalAddProps {
    roles: IAuthRoleModel[];
    onSubmit: (selectedRoleIds: number[]) => void;
    onCancel: () => void;
}

export interface IFormData {
    roleIds: number[]
}

export const UserProfileRolesModalAdd = ({ roles, onSubmit, onCancel }: UserProfileRolesModalAddProps) => {
    const { register, handleSubmit, watch } = useForm<IFormData>({
        shouldFocusError: true,
    });
    const selectedRoleIds = watch('roleIds'); // the current state of roles selections
    const enableSubmit = selectedRoleIds?.length; // only enable the submit if one or more roles is chosen.
    const parseRoles = (formData: IFormData) => {
        // for some reason react-hooks-forms can store values as strings, even thought we've typed them as numbers. 🤷🏻‍♂️
        const selectedRoles = formData.roleIds.map(r => typeof (r) === "string" ? parseInt(r) : r);
        onSubmit(selectedRoles);
    }

    return (
        <Modal centered className="confirm-dialog" show={!isEmpty(roles)} onHide={onCancel} data-testid="add-role-modal">
            <Modal.Header closeButton>
                <Modal.Title>Add New Roles</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <label htmlFor="roleIds" className="form-label visually-hidden">Choose one or more roles</label>
                    <select
                        className="form-select"
                        size={roles.length}
                        multiple={true}
                        {...register('roleIds')}
                        aria-label='available roles'
                        aria-describedby="selectedHelpBlock" >
                        {roles.map(r => <option key={r.authRoleId} aria-label={r.description} value={r.authRoleId}>{r.description}</option>)}
                    </select>
                    <Form.Text className="pt-2" id="selectHelpBlock" muted>Hint: Use Ctrl+click (Windows) or ⌘+click (Mac) to choose multiple roles.</Form.Text>
                </Form>
            </Modal.Body>
            <Modal.Footer className="container-fluid">
                <Button
                    aria-label="cancel"
                    variant="light"
                    className='cancel'
                    onClick={onCancel}>Cancel</Button>
                <Button
                    aria-label="submit"
                    variant="primary"
                    className='confirm'
                    disabled={!enableSubmit} // disable the submit button if no roles are selected.
                    onClick={handleSubmit(parseRoles)}>Add Roles</Button>
            </Modal.Footer>
        </Modal>
    )
};
